import React, { useState } from "react";
import { TspCard, TspFormField } from "../../../components/primitives";
import { formatDate } from "../../../utils/tspFormat";

// Submitting a daily report IS the report (the backend has no separate
// draft/submit step — see the Phase 3 report). The picker is built directly
// from the PENDING city visits (a visit that already has a report cannot be
// picked again — it simply is not offered), so there is no separate journey
// dropdown to keep in sync with it.
export default function DailyReportFormCard({ pending, pendingLoading, onSubmit }) {
  const [cityVisitId, setCityVisitId] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [activities, setActivities] = useState("");
  const [remarks, setRemarks] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const selected = pending.find((row) => String(row.city_visit_id) === cityVisitId);
  const requiredFilled = cityVisitId && reportDate;

  const handleSubmit = async () => {
    if (!requiredFilled || busy) return;
    setBusy(true);
    setError("");
    const result = await onSubmit({
      journey_id: selected.journey.id,
      city_visit_id: Number(cityVisitId),
      report_date: reportDate,
      ...(activities.trim() ? { activities: activities.trim() } : {}),
      ...(remarks.trim() ? { remarks: remarks.trim() } : {}),
    });
    setBusy(false);
    if (result.ok) {
      setCityVisitId("");
      setReportDate("");
      setActivities("");
      setRemarks("");
    } else {
      setError(result.message);
    }
  };

  return (
    <TspCard title="Submit Daily Report">
      {!pendingLoading && pending.length === 0 ? (
        <p className="tsp-muted-text">Every recorded city visit already has a report.</p>
      ) : (
        <>
          <div className="tsp-form-row">
            <TspFormField id="dr-visit" label="City Visit" required>
              <select id="dr-visit" className="tsp-field-control" value={cityVisitId} disabled={busy || pendingLoading} onChange={(e) => setCityVisitId(e.target.value)}>
                <option value="">{pendingLoading ? "Loading…" : "Select a city visit"}</option>
                {pending.map((row) => (
                  <option key={row.city_visit_id} value={row.city_visit_id}>
                    {row.journey.journey_name} — {row.location?.label} — {formatDate(row.visit_date)}
                  </option>
                ))}
              </select>
            </TspFormField>
            <TspFormField id="dr-date" label="Report Date" required>
              <input id="dr-date" type="date" className="tsp-field-control" value={reportDate} disabled={busy} onChange={(e) => setReportDate(e.target.value)} />
            </TspFormField>
          </div>
          <TspFormField id="dr-activities" label="Activities" className="tsp-span-2">
            <textarea id="dr-activities" className="tsp-field-control tsp-textarea" rows={3} value={activities} disabled={busy} onChange={(e) => setActivities(e.target.value)} />
          </TspFormField>
          <TspFormField id="dr-remarks" label="Remarks" className="tsp-span-2">
            <textarea id="dr-remarks" className="tsp-field-control tsp-textarea" rows={2} value={remarks} disabled={busy} onChange={(e) => setRemarks(e.target.value)} />
          </TspFormField>
          {error && (
            <p className="tsp-form-error" role="alert">
              {error}
            </p>
          )}
          <button type="button" className="tsp-btn tsp-btn-success" style={{ marginTop: 14 }} onClick={handleSubmit} disabled={!requiredFilled || busy}>
            {busy ? "Submitting…" : "Submit Report"}
          </button>
        </>
      )}
    </TspCard>
  );
}
